import { Link } from 'react-router-dom';

const ProductItem = ({ icon, slug, title }) => {
    return (
        <>
            <Link to={slug} className="product-item">
                <div className="product-item__image">
                    <img src={icon} alt={title} />
                </div>
                <div className="product-item__name">
                    <p className="body2">{title}</p>
                </div>
            </Link>
            {/* <Link to={product.slug} className="product-item">
                <div className="product-item__image">
                    <img src={product.icon} alt={product.title} />
                </div>
                <div className="product-item__name">
                    <p className="body2">{product.title}</p>
                </div>
            </Link> */}
        </>
    );
};

export default ProductItem;
